module.exports = __webpack_public_path__ + "media/img/Landing_Page/Institution-Banner-01-358394aef868cc79f6545213e174b8e7.png";